import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ExternalReviews} from '../../../../../../types/ExternalReviews';
import {ExternalReviewsSummary} from '../../../../../../types/ExternalReviewsSummary';
import {ExternalReviewsProsAndConsGrouped} from '../../../../../../types/ExternalReviewsProsAndConsGrouped';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {ExternalReviewsProsAndConsGroupedItem} from '../../../../../../types/ExternalReviewsProsAndConsGroupedItem';
import {ProsAndConsTypeEnum} from 'src/app/enums/ProsAndConsEnum';
import {CpruTabsService} from '../../../../../../services/cpru-tabs.service';
import {RoutesAddonsEnums} from '../../../../../../enums/RoutesEnums';

@Component({
  selector: 'app-cpru-reviews-short',
  templateUrl: './cpru-reviews-short.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block rounded-lg bg-grey-10 px-4 py-5 md:hidden',
  },
})
export class CpruReviewsShortComponent {
  public externalReviews = input<ExternalReviews>(null);
  public externalReviewsNormalized = computed<ExternalReviews>(() => {
    const normalizedReviews = this.externalReviews();
    if (normalizedReviews && normalizedReviews.data && normalizedReviews.data.ReviewSummary) {
      normalizedReviews.data.ReviewSummary = this.keysToCamelCase(normalizedReviews.data.ReviewSummary);
    }
    return normalizedReviews;
  });
  protected readonly ProsAndConsTypeEnum = ProsAndConsTypeEnum;
  private cpruTabsService = inject(CpruTabsService);
  private careProviderUnitService = inject(CareproviderUnitService);
  public prosAndConsGrouped = computed<ExternalReviewsProsAndConsGrouped>(() => {
    if (
      this.externalReviewsNormalized() &&
      this.externalReviewsNormalized().data &&
      this.externalReviewsNormalized().data.ReviewSummary
    ) {
      return this.careProviderUnitService.groupExternalReviewsItemsByFrequency(
        this.externalReviewsNormalized().data.ReviewSummary.pros,
        this.externalReviewsNormalized().data.ReviewSummary.cons,
      );
    }
  });
  private topProsAndConsCount = 4;
  public topProsAndCons = computed<ExternalReviewsProsAndConsGroupedItem[]>(() => {
    const topProsAndCons: ExternalReviewsProsAndConsGroupedItem[] = [];
    if (this.prosAndConsGrouped()) {
      if (this.prosAndConsGrouped().many) {
        this.prosAndConsGrouped().many.forEach((item) => {
          if (topProsAndCons.length < this.topProsAndConsCount) {
            topProsAndCons.push(item);
          }
        });
      }
      if (this.prosAndConsGrouped().some && topProsAndCons.length < this.topProsAndConsCount) {
        this.prosAndConsGrouped().some.forEach((item) => {
          if (topProsAndCons.length < this.topProsAndConsCount) {
            topProsAndCons.push(item);
          }
        });
      }
      if (this.prosAndConsGrouped().single && topProsAndCons.length < this.topProsAndConsCount) {
        this.prosAndConsGrouped().single.forEach((item) => {
          if (topProsAndCons.length < this.topProsAndConsCount) {
            topProsAndCons.push(item);
          }
        });
      }
    }
    return topProsAndCons;
  });

  public goToReviews(): void {
    this.cpruTabsService.changeTabAndScrollToSection(RoutesAddonsEnums.CAREPROVIDER_IMPRESSION);
  }

  private keysToCamelCase(obj: ExternalReviewsSummary): ExternalReviewsSummary {
    if (obj !== null && typeof obj === 'object') {
      return Object.entries(obj).reduce((accumulator, [key, value]) => {
        const camelKey = this.toCamelCase(key);
        accumulator[camelKey] = value;
        return accumulator;
      }, {} as ExternalReviewsSummary);
    } else {
      return obj;
    }
  }

  private toCamelCase(str: string): string {
    return str
      .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''))
      .replace(/^[A-Z]/, (match) => match.toLowerCase());
  }
}
